import '../Sidebar/Sidebardigital';
import Sidebar from '../Sidebar/Sidebardigital';
import React from 'react';

export default function Aboutus()
{
    return(
       <>
      <div className="row">
        <div className="col-2 custom-display">
          <Sidebar />
        </div>
        <div className="col-8 custom-width">
            <br/><br/><br/>
        <h1> ABOUT US</h1><br></br>
        <strong>VISION</strong><br></br>
        <p>Our vision is to create energy independent farms</p><br></br>
        <strong>MISSION</strong><br></br>
        <p>1. To be the best Agritech IOT solution provider for optimizing the usage of Agriculture inputs. These inputs would be include 
          Water, Electricity and fertilizers</p>
        <p>2. Use sustainable sources of energy for replacing the conventional sources of energy</p><br></br>


        <strong>Current Actions</strong><br></br>
        <p> Gatisheel is an IOT company which caters to the Agriculture sector. We are building a data powerhouse which is required for the critical decision making. Few of our use cases are as follows - 
            <br></br><br></br>
            1. Crop wise water usage pattern<br></br><br></br>
            2. Pump Error codes generated on the farm<br></br><br></br>
            3. Pump health data on the agriculture farm( usage vs power factor changes) <br></br><br></br>
            4. Resources usage data which can used by farming companies for their ESG report<br></br><br></br>
            5. Virtual water - import and export decision making<br></br><br></br>
            6. Data required by solar power companies - Electrical tubewell capacity, distribution and usage<br></br><br></br>
            7. Relationship between underground water level drop and water usage on the field <br></br><br></br>

            Journery of thousand miles starts with the single step. We are taking those baby steps which will make agriculture sustainable for the upcoming generations. 
        </p>
        <br/><br/>
        </div>
        <div className="col-2 custom-display">
          <Sidebar />
        </div>
        </div>
     </>
    )   
   };